import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "../features/modalSlice";
import languageReducer from "../features/languageSlice";

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("reduxState");
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("reduxState", serializedState);
  } catch {}
};

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    language: languageReducer,
  },
  preloadedState: persistedState,
});

store.subscribe(() => {
  saveState(store.getState());
});
